function trim(value) {
  return String(value || "").trim();
}

function readEnv(key, fallback = "") {
  const value = trim(process.env[key]);
  return value || fallback;
}

export const API_BASE = readEnv(
  "REACT_APP_API_BASE",
  readEnv("REACT_APP_API_URL", "")
).replace(/\/+$/, "");

export const MEDIA_BASE_URL = readEnv("REACT_APP_MEDIA_BASE_URL", "").replace(/\/+$/, "");
